<template>
  <div id="activity_l" v-loading="loading">
    <top></top>
    <div class="main">
      <div class="content">
        <title-background :title="'秀演活动列表'"></title-background>
        <el-table typ :data="tableData" stripe style="width: 100%">
          <!-- <el-table-column type="selection" width="80"> </el-table-column> -->
          <el-table-column
            show-overflow-tooltip
            prop="venue_name"
            label="活动名称"
            min-width="300"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="location"
            label="地点"
            min-width="200"
          >
          </el-table-column>
          <el-table-column
            label="票数"
            min-width="120"
            prop="brand_tickets"
          ></el-table-column>
          <el-table-column prop="start_time" label="开始时间" min-width="180">
          </el-table-column>
          <el-table-column
            prop="status_characters"
            label="状态"
            min-width="120"
          >
          </el-table-column>
          <el-table-column
            prop="verification_characters"
            label="审核状态"
            min-width="120"
          >
          </el-table-column>
          <el-table-column label="操作" min-width="240">
            <template slot-scope="scope">
              <div class="activity_l_actions">
                <span @click="toEditActivity(scope.row)">编辑</span>
                <span
                  v-if="scope.row.examine_status == 2"
                  @click="toInvitation(scope.row.id)"
                  >邀请函</span
                >
                <span
                  v-if="scope.row.examine_status == 2"
                  @click="toExamine(scope.row.id)"
                  >报名审批</span
                >
                <span style="display: flex;align-items: center;justify-content: center"
                    v-if="scope.row.examine_status == 2"
                    @click="down_code(scope.row.id)"
                >下载活动码</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="activity_l_footer">
          <div class="activity_l_button">
            <!-- <div class="declare_fillButton">批量删除</div> -->
          </div>
          <div class="activity_l_pagination">
            <el-pagination
              :current-page="currentPage"
              :page-size="pageSize"
              @change="handleCurrentPageChange"
              background
              layout="prev, pager, next"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import top from "../../components/top.vue";
import titleBackground from "../dataReview/json/titleBackground.vue";
import {getDictionary, getActivityList, downloadQrcode} from "../../api/api";
export default {
  name: "activityList",
  components: { top, titleBackground },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      upAndDownShelvesOptions: [],
      examineStatusOptions: [],
      loading: false,
    };
  },
  created() {
    this.getDict();
    this.getList();
  },
  methods: {
    async getDict() {
      this.loading = true;
      let dictionaryString =
        "?type=fashion_active_status,fashion_information_examine";
      const res = await getDictionary(dictionaryString);
      if (res.code == 1) {
        this.upAndDownShelvesOptions = res.data.fashion_active_status;
        this.examineStatusOptions = res.data.fashion_information_examine;
      } else {
        this.loading = false;
        this.$message.warning("获取数据字典失败！");
      }
    },
    async getList() {
      this.loading = true;
      let obj = {
        page_no: this.currentPage,
        page_size: this.pageSize,
      };
      const res = await getActivityList(this.$qs.stringify(obj));
      if (res.code == 1) {
        res.data.lists.forEach((item) => {
          for (let i = 0; i < this.upAndDownShelvesOptions.length; i++) {
            if (item.status == this.upAndDownShelvesOptions[i].value) {
              item.status_characters = this.upAndDownShelvesOptions[i].name;
            }
          }
          for (let j = 0; j < this.examineStatusOptions.length; j++) {
            if (item.examine_status == this.examineStatusOptions[j].value) {
              item.verification_characters = this.examineStatusOptions[j].name;
            }
          }
        });
        this.tableData = res.data.lists;
        this.total = res.data.count;
      } else {
        this.$message.warning("获取活动列表失败！");
      }
      this.loading = false;
    },
    handleCurrentPageChange(val) {
      this.currentPage = val;
      this.getList();
    },
    toEditActivity(row) {
      let id = row.id;
      let examineStatus = row.examine_status;
      if (examineStatus == 0) {
        this.$router.push({
          path: "/activityDetail",
          query: {
            id,
          },
        });
      } else {
        this.$router.push({
          path: "/activityReview",
          query: {
            id,
          },
        });
      }
    },
    toInvitation(id) {
      this.$router.push({
        path: "/invitationList",
        query: {
          id,
        },
      });
    },
    toExamine(id) {
      this.$router.push({
        path: "/ticketReview",
        query: {
          id,
        },
      });
    },
    async down_code(id) {
      let obj = {
        id: id,
      };
      try {
        const res = await downloadQrcode(this.$qs.stringify(obj));
        if (res.code == 1 && res.data.qrcode_img) {
          const url = res.data.qrcode_img;
          const match = url.match(/\/([^\/?#]+)(?:[?#]|$)/);
          const name = match ? match[1] : "小程序码.png";
          const response = await fetch(url);
          if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
          const blob = await response.blob();
          const blobUrl = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = blobUrl;
          a.download = name;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(blobUrl);
          this.$message.success("下载成功");
        } else {
          this.$message.warning("获取小程序码失败");
        }
      } catch (error) {
        this.$message.error("下载失败");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.activity_l_actions {
  display: flex;
  align-items: center;
  span {
    margin-right: 10px;
    cursor: pointer;
    color: #1677ff;
    font-size: 14px;
  }
  span:hover {
    font-weight: 500;
  }
}
.activity_l_footer {
  width: 100%;
  box-sizing: border-box;
  padding: 0 0 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 100px;
}
.code_image{
  width: 14px;
}
</style>
